import uniq from 'lodash.uniq';
import {ConvertorFieldTypeToDataType} from 'src/components/data-types/constants';
import {ColumnTypes} from 'src/modules/attributes/constants';
import {AttributeRelationInfo} from 'src/openapi/models/AttributeRelationInfo';

export const extractColumnHeaderData = (filteredRows: AttributeRelationInfo[], columnType: ColumnTypes): string[] => {
    if (columnType === ColumnTypes.EVENT_CODES) {
        return uniq(filteredRows.flatMap(row => row[columnType]));
    }

    if (columnType === ColumnTypes.DATA_TYPE) {
        return uniq(filteredRows.flatMap(row => row[columnType])
            .map(dataType => ConvertorFieldTypeToDataType[dataType]));
    }

    return uniq(filteredRows.map(row => row[columnType]));
};
